import React from 'react';
import { FaInstagram, FaLinkedin, FaArtstation } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi'

import SocialIcon from './socialIcon';

const SocialsGroup = () => {
  return (
    <div className="flex justify-center">
        <SocialIcon link="https://www.instagram.com/jcho42/">
        <FaInstagram />
        </SocialIcon>
        <SocialIcon link="https://www.artstation.com/jasoncho8/">
        <FaArtstation />
        </SocialIcon>
        <SocialIcon link="https://www.linkedin.com/in/jcho42/">
        <FaLinkedin />
        </SocialIcon>
        <SocialIcon link="mailto:jason.cho.301230@gmail.com?subject=Hello!">
        <HiOutlineMail />
        </SocialIcon>
    </div>
  );
};

export default SocialsGroup;